import React from "react";
import { Button, Input, Form, DatePicker, message, Select } from "antd";
import axiosJSON from "../../util/SetHeaderAPI";
import moment from "moment";

const FormItem = Form.Item;
const dateFormat = "YYYY-MM-DD";
const { Option } = Select;
export default class AddExperience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: [
        {
          name: "title",
          value: "",
        },
        {
          name: "remark",
          value: "",
        },
        {
          name: "start_date",
          value: "",
        },
        {
          name: "end_date",
          value: "",
        },
        {
          name: "company",
          value: "",
        },
        {
          name: "city",
          value: "",
        },
        {
          name: "exp_type",
          value: "",
        },
      ],
      candidate_id: this.props.id,
      experience_id: "",
      exp_type_list: [],
    };
    this.Mounted = false;
  }

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  componentWillUnmount() {
    this.Mounted = false;
  }

  componentDidMount() {
    this.Mounted = true;
    if (this.props.edit) {
      let fields = [
        {
          name: "title",
          value: this.props.data.title,
        },
        {
          name: "remark",
          value: this.props.data.remark,
        },
        {
          name: "start_date",
          value:
            this.props.data.start_date !== null
              ? moment(this.props.data.start_date)
              : "",
        },
        {
          name: "end_date",
          value:
            this.props.data.end_date !== null
              ? moment(this.props.data.end_date)
              : "",
        },
        {
          name: "company",
          value: this.props.data.company,
        },
        {
          name: "city",
          value: this.props.data.city,
        },
        {
          name: "exp_type",
          value: this.props.data.exp_type,
        },
      ];
      this.setState({
        fields: fields,
        candidate_id: this.props.data.candidate,
        experience_id: this.props.data.id,
      });
    }
    axiosJSON
      .get("api/choice/?type=experience")
      .then(({ data, status }) => {
        if (status === 200) {
          this.setState({ exp_type_list: data.data });
        }
      })
      .catch(function (error) {
        message.error(error.message);
      });
  }

  onFinish = (values) => {
    if (this.props.edit) {
      const body = values;
      body["candidate"] = parseInt(this.state.candidate_id);
      body["experience_id"] = this.state.experience_id;
      body["start_date"] = moment(body["start_date"]).format(dateFormat);
      body["end_date"] = moment(body["end_date"]).format(dateFormat);
      axiosJSON
        .put(
          "api/candidate/" +
            this.state.candidate_id +
            "/experience/" +
            this.state.experience_id +
            "/",
          body
        )
        .then(({ data, status }) => {
          if (status === 202) {
            message.success("Candidate Experience Added!");
            this.props.closeModal();
          }
        })
        .catch(function (error) {
          message.error(error.message);
        });
    } else {
      const body = values;
      body["candidate"] = parseInt(this.state.candidate_id);
      body["start_date"] = moment(body["start_date"]).format(dateFormat);
      body["end_date"] = moment(body["end_date"]).format(dateFormat);
      axiosJSON
        .post("api/candidate/" + this.state.candidate_id + "/experience/", body)
        .then(({ data, status }) => {
          if (status === 201) {
            message.success("Candidate Experience Added!");
            this.props.closeModal();
          }
        })
        .catch(function (error) {
          message.error(error.message);
        });
    }
  };

  render() {
    return (
      <div className="gx-login-container">
        <div className="gx-login-content experience-form">
          <Form
            name="basic"
            fields={this.state.fields}
            onFieldsChange={(newFields) => this.setState({ fields: newFields })}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            className="gx-signin-form gx-form-row0"
          >
            <FormItem
              name="title"
              label="Title"
              rules={[{ required: true, message: "Please enter title!" }]}
            >
              <Input
                className="gx-input-lineheight"
                type="text"
                placeholder="Job Title"
              />
            </FormItem>

            <FormItem name="remark" label="Experience Remark">
              <Input
                className="gx-input-lineheight"
                type="text"
                placeholder="Additional Remarks"
              />
            </FormItem>

            <FormItem
              name="start_date"
              label="Experience Start Date"
              rules={[{ required: true, message: "Please enter Start Date!" }]}
            >
              <DatePicker placeholder="Experience Start Date" />
            </FormItem>

            <FormItem
              name="end_date"
              label="Experience End Date"
              rules={[{ required: true, message: "Please enter End Date!" }]}
            >
              <DatePicker placeholder="Experience End Date" />
            </FormItem>

            <FormItem name="city" label="City">
              <Input
                className="gx-input-lineheight"
                type="text"
                placeholder="Job Location"
              />
            </FormItem>

            <FormItem
              name="company"
              label="Experience Company"
              rules={[
                { required: true, message: "Please enter company Name!" },
              ]}
            >
              <Input
                className="gx-input-lineheight"
                placeholder="Experience Company"
              />
            </FormItem>

            <FormItem
              name="exp_type"
              label="Experience Type"
              rules={[
                { required: true, message: "Please select Experience Type" },
              ]}
            >
              <Select>
                {this.state.exp_type_list.map((exp_type, index) => (
                  <Option key={index} value={exp_type.id}>
                    {exp_type.display_name}
                  </Option>
                ))}
              </Select>
            </FormItem>

            <FormItem>
              <Button type="primary" htmlType="submit">
                Submit Experience
              </Button>
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}
